export function validateModel(model) {
    var errors = [];

    // Three different states a line can be in: QUOTING, NOQUOTING or WILLADVISE
    // We evaluate lines in these states distinctly.

    var linesQuoting = model.lines.filter(l => l.disposition == 'QUOTING' || isNullOrWhitespace(l.disposition));
    var linesNoQuoting = model.lines.filter(l => l.disposition == 'NOQUOTING');
    var linesWillAdvise = model.lines.filter(l => l.disposition == 'WILLADVISE');

    //console.log(linesNoQuoting[0].no_quote_classification);

    // validate top-level data
    if( expirationValidity(model) == false ) { errors.push("Expiration cannot be blank or in the past"); }
    if( model.additional_costs.some(c => isNullOrWhitespace(c.label))) { errors.push("RFQ additional costs requires type."); }   

    // evaluate quoted lines
    if( linesQuoting.some(l => isNullOrWhitespace(l.description))) { errors.push("One or more Lines require a Description."); }        
    if( linesQuoting.some(l => l.part_number == null)) { errors.push("One or more Lines requires a Part Number."); }        

    if( linesQuoting.some(l => l.additional_costs.some(c => isNullOrWhitespace(c.label)))) { errors.push("Line Additional Costs requires a type"); }     

    // We test for "q.no_quote != true" because if they are no-quoting a quantity, we don't care about these values
    // We test for "!=true" rather than "==false" because these tend to be true or null, but not false.
    if( linesQuoting.some(l => l.quantities.some(q => numberIsNullOrZero(q.qty) && q.no_quote != true))) { errors.push("Line Quantity requires an amount"); }        
    if( linesQuoting.some(l => l.quantities.some(q => isNullOrWhitespace(q.uom) && q.no_quote != true))) { errors.push("Line Quantity requires a unit-of-measurement"); }        
    if( linesQuoting.some(l => l.quantities.some(q => numberIsNullOrZero(q.lead_time) && q.no_quote != true))) { errors.push("Line Quantity requires a Lead Time"); }        
    if( linesQuoting.some(l => l.quantities.some(q => numberIsNullOrZero(q.cost) && q.no_quote != true))) { errors.push("Line Quantity requires a Unit Cost"); }        
    if( linesQuoting.some(l => l.quantities.some(q => numberIsNullOrZero(q.condition) && q.no_quote != true))) { errors.push("Line Quantity requires a Condition"); }        
    
    // Special weird case.  User has no-quoted the one quantity from the solicitation, provided no
    // alternate quantities, and is trying to submit the quote.
    if( linesQuoting.some(l => l.quantities.length == 1 && l.quantities[0].no_quote == true)) { errors.push("Line has no usable Quantities; consider no-quoting the Line"); }        
    

    // validate no-quoting lines
    if( linesNoQuoting.some(l => isNullOrWhitespace(l.no_quote_classification))) { errors.push("No-Quoted Lines require a reason"); }  

    // validate "Other" no-quote classification requires a reason
    if( linesNoQuoting.some(l => l.no_quote_classification === 'Other' && isNullOrWhitespace(l.no_quote_other_reason))) { 
        errors.push("Lines with 'Other' no-quote reason must provide a description"); 
    }

    // validate will-advise lines
    if( linesWillAdvise.some(l => l.will_advise_dt == null)) { errors.push("Will-Advise Lines require a date"); }  

    
    return errors;
}

function numberIsNullOrZero(num) {
    console.log(typeof num);
    return (num == undefined || num == null || num === 0 | num === '' );
}

function isNullOrWhitespace(str){
    return (str == null || str == undefined || str.trim() == '');
}

function expirationValidity(model) {
    // We only need an expiration date if ANY lines are being quoted. 
    var state = false;
    var hasQuotedLines = model.lines.some(l => l.no_quote_classification == null && l.will_advise_dt == null);
    if(hasQuotedLines == false) { state = true; }  // if nothing is being quoted, no need for expiration
    var noQuoteOrWillAdviseSelected = model.lines.some(l => l.disposition == "NOQUOTING" || l.disposition == "WILLADVISE");
    if(noQuoteOrWillAdviseSelected == true) { return null; }
    else
    {
      // otherwise, some lines are quoted and we need that expiration
      const today = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate());
      var expDate = new Date(model.expiration_ts);
      //console.log("expDate = " + expDate);
      //console.log("today = " + today);
      //console.log("expDate > today = " + (expDate > today) )
      state = (model.expiration_ts != null && expDate > today );  // non-blank and greater than "today"
  }

    return state;
  }